import { Heading, Progress, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

type Props = unknown;

/**
 * SubmitScreen.
 * Submit screen when the onboarding is submitted
 *
 * @returns {JSX.Element}
 */
export function SubmitScreen(): JSX.Element {
  const i18nSubmitScreen = useTranslations('SubmitScreen');

  return (
    <Stack
      alignItems="center"
      bottom="0"
      flexGrow="1"
      h="full"
      justifyContent="center"
      p="6"
      position="absolute"
      spacing="2"
      top="0"
      w="full"
    >
      <Heading size="lg" textAlign="center">
        {i18nSubmitScreen('Title')}
      </Heading>
      <Text color="gray.600" fontWeight="normal">
        {i18nSubmitScreen('SubTitle')}
      </Text>
      <Progress isIndeterminate mt="1" size="xs" w="45%" />
    </Stack>
  );
}

export type SubmitScreenProps = Props;
